import { Component } from '@angular/core';
import { LookupService } from '../../services/lookups/lookup.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']

})
export class FooterComponent {

  constructor(private ls: LookupService) {}

  public disclaimerUrl: string = this.ls.getDefaultValue(40055, "xx");
  public privacyStatementUrl: string = this.ls.getDefaultValue(40056, "xx");

}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/anon/footer.component.ts